type Props = { bgcolor?: string; cta: string };

const FullWidthCta = ({
    bgcolor = 'bg-blue-baby',
    cta,
    children,
}: React.PropsWithChildren<Props>) => {
    return (
        <div
            className={`w-full p-4 md:p-6 flex flex-col md:flex-row justify-center items-center ${bgcolor}`}
        >
            <p className="font-bold text-black text-xl mb-4 text-center md:text-left md:text-2xl md:mb-0 md:mr-8">
                {cta}
            </p>
            {children}
        </div>
    );
};

export default FullWidthCta;
